module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"list_empty":"This list is empty.","rename":"Rename list","save":"Save","view":"View","view_list":"List","view_table":"Table"},"de":{"list_empty":"Diese Liste enthält noch keine Gegenstände.","rename":"Liste umbenennen","save":"Speichern","view":"Ansicht","view_list":"Liste","view_table":"Tabelle"}}')
  delete Component.options._Ctor
}
